import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Menu, X, HelpCircle } from 'lucide-react';

const NavigationProfessionnels = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  
  const menuItems = [
    {
      name: 'Accueil',
      path: '/professionnels'
    },
    {
      name: 'Nos solutions',
      path: '/nos-services'
    },
    {
      name: 'Location saisonnière',
      path: '/demande-saisonnier'
    },
    {
      name: 'Parcs vélos',
      path: '/achat-parcs-velo'
    },
    {
      name: 'Bornes réparation',
      path: '/borne-autoreparation'
    },
    {
      name: 'Groupes',
      path: '/demande-groupe'
    },
    {
      name: 'Collectivités',
      path: '/collectivites'
    },
    {
      name: 'Contact',
      path: '/nous-contacter'
    }
  ];

  return (
    <nav className="bg-white/95 backdrop-blur-sm border-b border-emerald-200 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img 
              src="/images/logo hirondelles fond transparent.jpg" 
              alt="Les Hirondelles - Professionnels" 
              className="w-auto transition-transform duration-300 group-hover:scale-105 h-[40px] object-cover" 
            />
          </Link>

          {/* Desktop Menu - Center */}
          <div className="hidden xl:flex items-center space-x-1">
            {menuItems.map(item => (
              <Link 
                key={item.path} 
                to={item.path} 
                className={`px-2.5 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                  location.pathname === item.path 
                    ? 'bg-emerald-600 text-white shadow-sm' 
                    : 'text-gray-700 hover:text-emerald-600 hover:bg-emerald-50'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          {/* Compact Desktop Menu for smaller screens */}
          <div className="hidden lg:flex xl:hidden items-center space-x-1">
            {menuItems.slice(0, 5).map(item => (
              <Link 
                key={item.path} 
                to={item.path} 
                className={`px-2 py-2 rounded-lg text-xs font-medium transition-all duration-200 ${
                  location.pathname === item.path 
                    ? 'bg-emerald-600 text-white shadow-sm' 
                    : 'text-gray-700 hover:text-emerald-600 hover:bg-emerald-50'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          {/* Action Buttons - Right */}
          <div className="hidden md:flex items-center space-x-3">
            {/* Primary CTA - Demander un devis */}
            <Button asChild className="bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-5 py-2 rounded-lg shadow-md hover:shadow-lg transition-all duration-300">
              <Link to="/nous-contacter">Devis</Link>
            </Button>
            
            {/* Secondary CTA - Nos services */}
            <Button asChild variant="outline" className="border-emerald-300 text-emerald-600 hover:bg-emerald-50 font-medium px-4 py-2 rounded-lg transition-all duration-300">
              <Link to="/nos-services">Solutions</Link>
            </Button>
            
            {/* FAQ Button - Circular */}
            <Button asChild variant="ghost" size="icon" className="rounded-full w-9 h-9 hover:bg-emerald-50 transition-all duration-300">
              <Link to="/faq">
                <HelpCircle className="h-4 w-4 text-emerald-600" />
              </Link>
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setIsOpen(!isOpen)}
              className="rounded-full"
            >
              {isOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </Button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t border-emerald-200">
              {menuItems.map(item => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`block px-3 py-2 rounded-md text-base font-medium transition-colors ${
                    location.pathname === item.path
                      ? 'bg-emerald-600 text-white'
                      : 'text-gray-700 hover:text-emerald-600 hover:bg-emerald-50'
                  }`}
                  onClick={() => setIsOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              
              {/* Mobile CTA Buttons */}
              <div className="pt-4 space-y-2">
                <Link to="/nous-contacter" onClick={() => setIsOpen(false)}>
                  <Button className="w-full bg-emerald-600 hover:bg-emerald-700 text-white">
                    Demander un devis
                  </Button>
                </Link>
                <Link to="/nos-services" onClick={() => setIsOpen(false)}>
                  <Button variant="outline" className="w-full border-emerald-300 text-emerald-600 hover:bg-emerald-50">
                    Nos services
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default NavigationProfessionnels;